var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"name":"LayoutPublic"}},[_c('div',{staticClass:"try-out-result layout__content"},[_c('h1',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('menuEngineering.overview.categoryCompare'))+" "),_c('span',{staticClass:"dish-category"},[_vm._v("\""+_vm._s(_vm.$t('menuEngineering.categories.' + _vm.category))+"\"")])]),_c('content-blocks',{attrs:{"blocks":_vm.blocks}}),_c('b-button',{attrs:{"rounded":"","type":"is-primary","tag":"router-link","to":{
        path: '/auth',
        query: {
          redirect: '/menu-engineering/add-dish',
          state: 'signUp',
        },
      }}},[_vm._v(_vm._s(_vm.$t('menuEngineering.try-out.result.sign-up')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }